import { z } from "zod";

import { packagingSolutionProducedSchema } from "../packaging-solution";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

export const auditEventProducedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Produced),
	data: packagingSolutionProducedSchema,
});

export type AuditEventProduced = z.infer<typeof auditEventProducedSchema>;
